import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Company panel → Mood Tracking: the check-in dashboard and the employee list.
 *
 * Built on the Mood Log check-in (emotion + context), not the legacy slider
 * moods that feed the main dashboard's positivity widgets. Notes and photos
 * attached to a check-in are never surfaced anywhere in this section.
 */
const CompanyMoodLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';

  const pages = [
    {
      label: 'Mood Dashboard',
      path: `/${slug}/mood`,
      description: 'Reach, mood balance, the emotions people name and the context around them'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `/${slug}/mood/users`,
      description: `Per-${population.replace(/s$/, '')} check-in records`
    }
  ];

  return (
    <CompanySectionLayout
      title="Mood Tracking"
      subtitle={`How your ${population} are feeling — what they name, when they log it, and the situations behind it.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyMoodLayout;
